var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h2"},[_c('h2',[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":require(("@/assets/images/" + _vm.text + ".png"))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }